export default "__VITE_ASSET__BPA5efgf__"